import React, { useEffect, useState } from 'react';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { QRCodeCanvas } from 'qrcode.react';
import './Certificate.css';
import certificate from '../../Assets/certificate_.png';
import axios from 'axios';
import { CERTIFICATE_URL } from '../../Services/courseService';
import { ClipLoader } from 'react-spinners';

const Certificate = ({ isLoading, userId, courseId }) => {
  const [certificateData, setCertificateData] = useState(null);
  const [loading, setLoading] = useState(isLoading);
  const [error, setError] = useState(null);
 
  useEffect(() => {
    const fetchCertificateData = async () => {
      try {
        const response = await axios.get(`${CERTIFICATE_URL}/certificates/data?userId=${userId}&courseId=${courseId}`);
        setCertificateData(response.data);
      } catch (err) {
        setError('Error fetching certificate data');
      } finally {
        setLoading(false);
      }
    };

    fetchCertificateData();
  }, [userId, courseId]);

  if (loading) {
    return  <ClipLoader color="#333333" loading={loading} size={30} id='clipLoader' />
    ;
  }

  if (error) {
    return <div>{error}</div>;
  }

  if (!certificateData) {
    return <div>No certificate data available</div>;
  }

  const { userName, courseName, completionDate } = certificateData;

  const handleDownload = () => {
    const element = document.getElementById('certificate');
    html2canvas(element, { scale: 4 })
      .then((canvas) => {
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF({
          orientation: 'landscape',
          unit: 'mm',
          format: [297, 210],
        });

        const imgWidth = 297;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
        pdf.save('certificate.pdf');
      })
      .catch((error) => {
        console.error("Error generating certificate:", error);
      });
  };
   
  return (
    <div>
      <div id="certificate" className="certificate-container">
        <img src={certificate} alt="Certificate Background" className="certificate-bg" />
        <div className="certificate-content">
          <h1>{userName}</h1>
          <h2>{courseName}</h2>
          <p>{completionDate}</p>

          {/* <p>{new Date(completionDate).toLocaleDateString()}</p> */}
        </div>

        <div className="qr-code-container">
          <QRCodeCanvas 
            value={`${process.env.REACT_APP_API_FRONTEND}/certificate/${userId}/${courseId}`}
            size={100}
            scale={5}    id="qr-code"
          />
        </div>
      </div>
      
      <button onClick={handleDownload} aria-label="Download Certificate" className="submit-certificate-button">
        Download Certificate
      </button>
    </div>
  );
};

export default Certificate;